import { render, staticRenderFns } from "./vh_p_n_in.vue?vue&type=template&id=72d2f583&scoped=true"
import script from "./vh_p_n_in.vue?vue&type=script&lang=js"
export * from "./vh_p_n_in.vue?vue&type=script&lang=js"
import style0 from "./vh_p_n_in.vue?vue&type=style&index=0&id=72d2f583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2f583",
  null
  
)

export default component.exports